// Invitations API Service - Frontend
// Handles all invitation-related API calls

const API_BASE = process.env.REACT_APP_API_URL || 'https://api.forwardsflow.com/api/v1';

const getAuthToken = () => localStorage.getItem('authToken') || sessionStorage.getItem('authToken');

const apiCall = async (endpoint, options = {}) => {
  const token = getAuthToken();
  const config = {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
      ...options.headers,
    },
  };

  const response = await fetch(`${API_BASE}${endpoint}`, config);
  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(error.error || error.message || 'Request failed');
  }
  return response.json();
};

export const invitationsApi = {
  // List all invitations (Platform Admin)
  list: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.type) params.append('type', filters.type);
    if (filters.status) params.append('status', filters.status);
    return apiCall(`/invitations?${params.toString()}`);
  },

  // Create bank invitation (Platform Admin)
  inviteBank: async (data) => {
    return apiCall('/invitations/bank', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  // Create investor invitation (Platform Admin)
  inviteInvestor: async (data) => {
    return apiCall('/invitations/investor', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  // Create staff invitation (Bank/Investor Admin)
  inviteStaff: async (data) => {
    return apiCall('/invitations/staff', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  // Verify invitation token (Public)
  verify: async (token) => {
    return fetch(`${API_BASE}/invitations/verify/${token}`).then(res => {
      if (!res.ok) throw new Error('Invalid token');
      return res.json();
    });
  },

  // Confirm invitation (Public)
  confirm: async (token) => {
    return fetch(`${API_BASE}/invitations/confirm/${token}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    }).then(res => {
      if (!res.ok) return res.json().then(e => { throw new Error(e.error); });
      return res.json();
    });
  },

  // Resend invitation
  resend: async (id) => {
    return apiCall(`/invitations/${id}/resend`, { method: 'POST' });
  },

  // Cancel invitation
  cancel: async (id) => {
    return apiCall(`/invitations/${id}`, { method: 'DELETE' });
  },
};

export default invitationsApi;
